<template>
    <div>
        <modal ref="modal" :disable-close="true" :content-class="'md:mt-20'">
            <alert ref="alert"></alert>

            <div class="bg-purple-900 flex flex-col w-full h-full p-10 overflow-y-auto">
                <h1 class="font-light">
                    {{ $t('your_subscription_payment_is_pending') }}
                </h1>

                <div class="pt-10">
                    {{ $t('we_are_waiting_your_payment_approval') }}
                </div>

                <div class="pt-10">
                    <button class="btn btn-orange" @click="refresh()" :disabled="loading">
                        {{ $t('refresh') }}
                    </button>

                    <button class="btn btn-blue mt-2" v-for="(action, k) in pendingActions"
                            :key="k"
                            @click="executeAction(action)" :disabled="loading">
                        {{ action.name }}
                    </button>

                    <button class="btn mt-2" @click="change()" :disabled="loading">
                        {{ $t('change_payment_method') }}
                    </button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    import {Auth, Zapin} from "@/services/Api";

    export default {

        mounted() {
            this.$refs.modal.open();

            if(!Auth.currentUser().hasSubscription()) {
                this.$router.push({
                    name: 'Plans'
                })
            }

            this.loadActions();
        },

        data() {
            return {
                loading: false,
                pendingActions: []
            }
        },

        methods: {
            goHome() {
                this.$router.push({
                    path: '/'
                });
            },

            loadActions() {
                Zapin
                    .subscription()
                    .pendingActions()
                    .then(res => {
                        this.pendingActions = res.data;
                    })
            },

            executeAction(action) {
                if(action.type === 'open_url') {
                    window.open(action.url, '_blank');
                }

                if(action.type === 'redirect_path') {
                    this.$router.push(action.url)
                }
            },

            refresh() {
                this.loading = true;

                Zapin
                    .updateUserData()
                    .then(() => {
                        if(Auth.currentUser().subscriptionIsActive()) {
                            this.goHome();
                        } else {
                            this.$refs.alert.info(this.$t('payment_nothing_yet'));
                        }
                    })
                    .finally(() => this.loading = false);
            },

            change() {
                if(confirm(this.$t('are_your_sure_change_payment_method'))) {
                    this.loading = true;

                    Zapin
                        .subscription()
                        .cancelPending()
                        .then(() => {
                            Zapin
                                .updateUserData()
                                .then(() => this.goHome())
                        })
                        .catch(err => {
                            if(err.status === 422)
                                this.$refs.alert.showValidationErrors(err);
                            else if (err.data.data.message)
                                this.$refs.alert.show(err.data.data.message);

                            this.$refs.alert.show(this.$t('unknown_error_try_again'));
                        })
                        .finally(() => this.loading = false);
                }
            }
        }

    }
</script>